<template>
    <main>
        <section>
            <div class="align-content-center m-4">
                <div class="page_title" style="display: flex;justify-content: center;">
                    <div>
                        <h3 class="page_title" style="display: inline-block;
                        height: 4.1rem;
                        border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Order inquiry </h3>
                    </div>

                </div>
            </div>
        </section>
        <section>
            <div style="width: 100%;margin: 0 auto;">
                <table style="width: 100%;background-color: #1D1D1B;margin: 0 auto;min-height: 800px;">
                    <tr>
                        <td class="col-md-1-1"
                            style="vertical-align: top; padding: 0;background-color: transparent;border-right: 1px solid #424242;">
                            <section style="background-color: transparent;">
                                <table style="width: 100%;">
                                    <tr style="height: 40px;background-color: #434343;">
                                        <td>
                                            Classification
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="tree-box" style="width: 100%;min-width: 200px;">

                                                <div class="tree-content" style="overflow: hidden;">
                                                    <el-tree ref="treeleft" :data="treeleftData" node-key="id"
                                                        v-if="treeleftData.length > 0" :indent="0" class="tree-line"
                                                        :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                                                        :default-expand-all="true" :highlight-current="false"
                                                        :expand-on-click-node="false" @node-click="handleNodeClick">
                                                        <span slot-scope="{ data }" class="custom-tree-node">
                                                            <template>
                                                                <div class="node_div">
                                                                    <span class="name-box">
                                                                        {{ data.name }}<span
                                                                            v-if="data.itemNum>0">({{data.itemNum}})</span>
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </span>
                                                    </el-tree>
                                                    <p v-if="treeleftData.length === 0" style="color: #6E7175;">
                                                        No Data Available
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </section>
                        </td>
                        <td class="container col-md-10-1" style="vertical-align: top;padding: 0;">
                            <div style="background-color: transparent;min-height: 300px;">
                                <table
                                    style=" background-color: #434343;text-align: center; line-height: 1;width: 100%; color: #D9D9D9;">
                                    <thead>
                                        <tr style="height: 40px;">
                                            <td style="width: 60px;">
                                                No.
                                            </td>
                                            <td scope="col" style="width: 150px;">
                                                Order Date
                                            </td>
                                            <td scope="col" style="width: 150px;">
                                                Shipping Date
                                            </td>
                                            <td scope="col" style="width: 150px;">
                                                Ready Date
                                            </td>
                                            <td scope="col" style="width: 200px;">
                                                PI/CI No.
                                            </td>
                                            <td scope="col" style="width: 100px;">
                                                P/O No.
                                            </td>
                                            <td scope="col" style="width: 150px;">
                                                Shipped From
                                            </td>
                                            <td scope="col" style="width: 150px;">
                                                Shipped To
                                            </td>
                                            <td scope="col" style="width: 180px;">
                                                ERP Tracking No.
                                            </td>
                                            <td scope="col">
                                                Notes
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody style="background-color:#1D1D1B;line-height: 25px;">
                                        <tr v-for="(item,index) in paginatedData" :key="index"
                                            class="text-muted highlight"
                                            style="height: 20px;color: #606266;padding-top: 15px;"
                                            @click="quoClick(item)">
                                            <td>{{index+1}}</td>
                                            <td>{{item.date}}</td>
                                            <td style="text-align: left;">{{item.sendDate}}</td>
                                            <td>{{item.exDate}}</td>
                                            <td>{{item.piNo}}</td>
                                            <td style="text-align: left;">{{item.poNo}}</td>
                                            <td style="text-align: left;">{{item.shipFrom}}</td>
                                            <td style="text-align: left;">{{item.shipTo}}</td>
                                            <td>{{item.quoNo}}</td>
                                            <td style="text-align: left;padding-left: 10px;"></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <el-pagination background layout="prev, pager, next" :hide-on-single-page="true"
                                    :total="totalData" :page-size="pageSize" @current-change="handleCurrentChange"
                                    :current-page="currentPage" style="margin-top: 20px;margin-bottom: 20px;"  >
                                </el-pagination>
                            </div>

                            <table style=" background-color: #434343;text-align: center;width: 100%;">
                                <thead>
                                    <tr style="height: 40px;">
                                        <td style="width: 60px;">
                                            No.
                                        </td>
                                        <td scope="col" style="width: 200px;">
                                            Customer part#
                                        </td>
                                        <td scope="col" style="width: 180px;">
                                            Items
                                        </td>
                                        <td scope="col" style="width: 380px;">
                                            Parts Description
                                        </td>
                                        <td scope="col" style="width: 80px;">
                                            Picture
                                        </td>
                                        <td scope="col" style="width: 120px;">
                                            Ctn
                                        </td>
                                        <td scope="col" style="width: 120px;">
                                            Qty
                                        </td>
                                        <td scope="col" style="width: 120px;">
                                            Certificates
                                        </td>
                                        <td scope="col" style="width: 120px;">
                                            Instructions
                                        </td>
                                        <td scope="col">
                                            Notes
                                        </td>
                                    </tr>
                                </thead>
                                <tbody style="background-color:#212120;line-height: 25px;">
                                    <tr v-for="item in tableBottomData" :key="item.no" class="highlight text-muted"
                                        style="height: 20px; ">
                                        <td>{{item.no}}</td>
                                        <td>{{item.cusCode}}</td>
                                        <td style="text-align: left;padding-left: 20px;">{{item.code}}</td>
                                        <td style="text-align: left;padding-left: 20px;">{{item.name}}</td>
                                        <td>
                                            <!-- <img class="card-img" :src="item.picture" alt="Card image"
                                                style="max-height: 9rem;"> -->
                                            <!-- <a href="#" v-if="item.picture">1</a> -->
                                            <a v-if="item.picNum" href="#" @click="showPic(item)"
                                                style="color: #4990e2; text-decoration: underline;">
                                                {{item.picNum}}</a>
                                            <a href="#" v-else>0</a>
                                        </td>
                                        <td>{{item.sendNum}}</td>
                                        <td>{{item.quoNum}}</td>
                                        <td>
                                            <a href="#" style="color: #4990e2; text-decoration: underline;"
                                                target="_blank"
                                                @click.prevent="downLoadCert(item.partID,item.certNum)">{{item.certNum}}</a>
                                        </td>
                                        <td><a href="#">{{item.instructions}}</a> </td>
                                        <td style="text-align: left;padding-left: 10px;">{{item.notes}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>


                </table>

            </div>
            <!-- 弹窗 -->
            <div v-if="dialogVisible" class="popup" style="width: 75%;height: 92%;max-width: 1000px;">

                <div style="height: 30px;text-align: right; background-color: #262626;padding-top: 5px;">
                    <img src="/assets/img/Main/popMin.png" alt="" @click="dialogVisible = false"
                        style="margin-right: 20px;">
                    <img src="/assets/img/Main/popMax.png" alt="" @click="dialogVisible = false"
                        style="margin-right: 20px;">
                    <img src="/assets/img/Main/popExit.png" alt="" @click="dialogVisible = false"
                        style="margin-right: 20px;">

                </div>

                <div style="overflow: auto;max-height: 845px;">

                    <div
                        style="text-align: center;padding-left: 10px;padding-right: 10px; align-items: center;justify-content: center;display: flex; height: 845px;">
                        <img :src="imageSrc" alt="">
                    </div>
                </div>
            </div>
            <el-dialog title="DOWNLOAD" :visible.sync="pdfVisible" width="650px" :before-close="detailClose">
                <el-table :data="downloadList" height="auto" border style="width: 100%">
                    <el-table-column prop="name" label="name" width="508">
                    </el-table-column>
                    <el-table-column label="download" width="100">
                        <template slot-scope="scope">
                            <span @click="cellClick(scope.row.name)"
                                style="padding-left: 20px;color: #4990e2; text-decoration: underline;">
                                1
                            </span>
                        </template>
                    </el-table-column>

                </el-table>
            </el-dialog>
        </section>

    </main>
</template>
<script>

    import { getQuoTreeNum, getQuoMain, getQuoDetail } from "@/api/rbac/quotation";
    import { getPartImg, getPartCertPdf } from "@/api/rbac/certificate";
    export default {
        data() {
            return {
                tableData: [],
                tableTopData: [],
                tableBottomData: [],
                treeleftData: [],
                downloadList: [],
                dialogVisible: false,
                pdfVisible: false,
                imageSrc: '',
                // 当前页码
                currentPage: 1,
                // 每页显示的数据条数
                pageSize: 15,
                // 总数据条数
                totalData: 0,
            };
        },
        computed: {
            user() {
                return this.$store.state.user; // 使用计算属性来获取用户信息，这样当用户信息变化时，界面也会自动更新
            },
            paginatedData() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = this.currentPage * this.pageSize;
                return this.tableTopData.slice(start, end);
            },
        },
        created() {
            this.getTreeList()
        },
        methods: {
            Expandcollapse() {
                this.isLeftExp = !this.isLeftExp;
                const nodes = this.$refs.treeleft.store._getAllNodes();
                for (let key in nodes) {
                    nodes[key].expanded = this.isLeftExp;
                }
            },
            getTreeList() {
                var strWhere = ''
                if (!this.user && !this.$isDevelopment) {
                    this.treeleftData = []
                    this.tableTopData = []
                    this.tableBottomData = []
                }
                else {
                    if (!this.$isDevelopment) {
                        strWhere = ' and b.id=' + this.user.id
                    }

                    getQuoTreeNum({ strWhere: strWhere }).then(res => {
                        this.treeleftData = res.data;
                        if (res.data.length == 0) {
                            this.tableTopData = []
                            this.tableBottomData = []
                        }
                        else {
                            this.getQuoTop(strWhere)
                        }
                        if (this.treeleftData.length > 0 && this.treeleftData[0].children.length > 0) {
                            this.$nextTick(() => {
                                this.$refs.treeleft.setCurrentKey(this.treeleftData[0].id);
                            });
                        }
                    })
                }

            },
            getQuoTop(strWhere) {
                getQuoMain({ strWhere: strWhere }).then(res => {
                    this.tableTopData = res.data;
                    this.totalData = res.data.length
                    if (res.data.length == 0) {
                        this.tableBottomData = []
                    }
                    else {
                        this.getQuoDetail(' and b.piid=' + this.tableTopData[0].piID)
                    }
                })
            },
            getQuoDetail(strWhere) {
                getQuoDetail({ strWhere: strWhere }).then(res => {
                    this.tableBottomData = res.data;
                })
            },
            handleNodeClick(node) {
                var strWhere = ''
                // if (!this.user) {
                //     if (this.$isDevelopment) {
                //         strWhere = ' and b.id=184798'
                //     }
                //     else{
                //         strWhere=' and 1=2'
                //     }
                // }
                // else {
                //     strWhere = ' and b.id=' + this.user.id
                // }
                if (!this.$isDevelopment) {
                    strWhere = ' and b.id=' + this.user.id
                }
                var unionWhere = ''
                if (node.realID != -1) {
                    unionWhere = ' and a.state=' + node.realID
                }
                this.getQuoTop(strWhere + unionWhere)
            },
            quoClick(item) {
                this.getQuoDetail(' and b.piid=' + item.piID)
            },
            showPic(data) {
                this.dialogVisible = true
                getPartImg({ id: data.partID }).then(res => {
                    this.imageSrc = window.URL.createObjectURL(res.data)
                })
            },
            downLoadCert(id, itemNum) {
                if (itemNum > 0) {
                    //根据ID获取文件地址
                    try {
                        getPartCertPdf({ id: id }).then(res => {
                            this.downloadList = res.data
                            if (res.data.length == 1) {
                                // const fileUrl = res.data[0].url; // 文件的URL地址
                                const filename = res.data[0].name; // 文件的名

                                // 获取完整的URL
                                // const fullUrl = window.location.href;
                                // 获取协议
                                const protocol = window.location.protocol;
                                // 获取主机名
                                const hostname = window.location.hostname;
                                // 获取端口号
                                const port = window.location.port;
                                const httpUrl = protocol + '//' + hostname + ':' + port + '/assets/img/Certificate/' + filename
                                const a = document.createElement('a');
                                a.href = httpUrl;
                                a.download = filename;
                                a.click();
                            }
                            if (res.data.length > 1) {
                                this.pdfVisible = true;
                            }
                        })
                    } catch (error) {
                        console.error('获取失败:', error);
                    }
                }
            },
            cellClick(name) {
                // 获取协议
                const protocol = window.location.protocol;
                // 获取主机名
                const hostname = window.location.hostname;
                // 获取端口号
                const port = window.location.port;
                const httpUrl = protocol + '//' + hostname + ':' + port + '/assets/img/Certificate/' + name

                const a = document.createElement('a');
                a.href = httpUrl;
                a.download = name;
                a.click();
                // window.open(httpUrl)
            },
            detailClose() {
                this.downloadList = [];
                this.pdfVisible = false;
            },
            // 当前页码改变时的处理函数
            handleCurrentChange(page) {
                this.currentPage = page;
            },
        },
    };
</script>
<style scoped>
    .tree-line {
        background-color: transparent;
        color: #D3D3D2;
    }

    ::v-deep .el-tree-node.is-current>.el-tree-node__content {
        background: #FCB42E !important;
        color: black;
    }

    table td {
        padding-top: 10px;
        font-size: 14px;
    }

    table a {
        text-decoration: underline;
        color: green;
    }

    .popup {
        position: fixed;
        top: 53%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #424242;
        /* border: 1px solid #ccc; */
        border-bottom: 10px solid #262626;
        border-left: 10px solid #262626;
        border-right: 10px solid #262626;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
    }

    /* 修改表头背景色为深色 */
    :deep(.el-dialog__header) {
        background-color: #303133 !important;
        /* 深灰色背景 */
        color: white !important;
        /* 白色文字 */
    }

    /* 修改标题文字颜色 */
    :deep(.el-dialog__title) {
        color: #ffffff !important;
    }

    /* 修改内容区域背景色为深色 */
    :deep(.el-dialog__body) {
        background-color: #303133 !important;
        /* 更深的背景色 */
        color: #c0c4cc !important;
        /* 浅灰色文字 */
        padding-top: 0px;
        padding-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
    }

    /* 修改底部按钮区域背景色 */
    :deep(.el-dialog__footer) {
        background-color: #303133 !important;
        /* 深灰色背景 */
        border-top: 1px solid #404040 !important;
        /* 添加分隔线 */
    }
</style>